import { useQuery, useQueryClient } from "@tanstack/react-query";
import { CalendarRange } from "lucide-react";
import { getMeta } from "../lib/api";
import { setSeasonPick, useSeasonPick } from "../hooks/useSeason";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./ui/select";

const autoLabel = (m) =>
  !m ? "Latest" : m.gamesSeason === m.statsSeason ? `${m.gamesSeason} Season` : `${m.gamesSeason} Games · ${m.statsSeason} Stats`;

export const SeasonPicker = () => {
  const qc = useQueryClient();
  const pick = useSeasonPick();
  const { data: meta } = useQuery({ queryKey: ["meta"], queryFn: getMeta });
  const { data: autoMeta } = useQuery({
    queryKey: ["meta-auto"],
    queryFn: () => getMeta({ auto: true }),
  });

  const onChange = (v) => {
    setSeasonPick(v);
    qc.resetQueries({ predicate: (q) => q.queryKey[0] !== "meta-auto" });
  };

  return (
    <Select value={pick} onValueChange={onChange}>
      <SelectTrigger
        data-testid="season-picker"
        className="h-9 w-auto gap-2 rounded-none border-border bg-secondary px-3 text-xs font-semibold uppercase tracking-wider"
      >
        <CalendarRange className="w-4 h-4 text-primary" />
        <span data-testid="season-picker-value" className="whitespace-nowrap">
          {pick === "auto" ? autoLabel(autoMeta) : `${pick} Season`}
        </span>
      </SelectTrigger>
      <SelectContent className="rounded-none">
        <SelectItem value="auto" data-testid="season-option-auto">
          Latest · {autoLabel(autoMeta)}
        </SelectItem>
        {(meta?.seasons || []).map((s) => (
          <SelectItem key={s} value={s} data-testid={`season-option-${s}`}>
            {s} Season
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
